const APP_VERSION = '1.10.0';
export default APP_VERSION;
